var _rect, _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFaceGood = function SvgFaceGood(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    x: 1,
    y: 1,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 3,
    vectorEffect: "non-scaling-stroke"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.98,
    cy: 6.71,
    r: 0.84,
    fill: "currentColor",
    stroke: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.01,
    cy: 6.71,
    r: 0.84,
    fill: "currentColor",
    stroke: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.06 12.46c2.79.06 4.17-.88 4.17-.88s-.93 2.87-4.2 2.8c-3.27-.07-4.2-2.98-4.2-2.98s1.33.99 4.23 1.05v.01Z",
    clipRule: "evenodd"
  })));
};
export default SvgFaceGood;